import { Controller } from "@hotwired/stimulus"

/** Multi-step assignment wizard: filter, exclusive set vs tests, and MMPI norms. */
export default class extends Controller {
  static targets = [
    "step",
    "search",
    "item",
    "setInput",
    "testInput",
    "setNameField",
    "selectedCount",
    "normField",
    "normSelect",
    "nextButton",
    "submit"
  ]
  static values = {
    genderCodes: { type: Array, default: [] }
  }

  connect() {
    this.showStep(0)
    this.sync()
  }

  filter() {
    const query = (this.hasSearchTarget ? this.searchTarget.value : "").trim().toLowerCase()
    this.itemTargets.forEach((el) => {
      const hay = (el.dataset.searchText || "").toLowerCase()
      el.classList.toggle("is-hidden", query !== "" && !hay.includes(query))
    })
  }

  selectSet() {
    this.testInputTargets.forEach((input) => {
      input.checked = false
    })
    this.sync()
  }

  selectTest() {
    this.setInputTargets.forEach((input) => {
      input.checked = input.value === ""
    })
    this.sync()
  }

  next(event) {
    event.preventDefault()
    if (!this.hasSelection()) return
    this.showStep(1)
    this.sync()
  }

  back(event) {
    event.preventDefault()
    this.showStep(0)
  }

  sync() {
    const testCount = this.selectedTestCodes().length
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = String(testCount)
    }
    if (this.hasSetNameFieldTarget) {
      this.setNameFieldTarget.classList.toggle("is-hidden", testCount < 2 || Boolean(this.selectedProcessId()))
    }
    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.disabled = !this.hasSelection()
    }

    const needsNorms = this.needsNorms()
    if (this.hasNormFieldTarget) {
      this.normFieldTarget.classList.toggle("is-hidden", !needsNorms)
    }
    if (this.hasNormSelectTarget) {
      this.normSelectTarget.disabled = !needsNorms
    }
  }

  showStep(index) {
    this.stepTargets.forEach((step) => {
      const current = Number(step.dataset.step) === index
      step.classList.toggle("is-hidden", !current)
    })
  }

  hasSelection() {
    return Boolean(this.selectedProcessId()) || this.selectedTestCodes().length > 0
  }

  selectedProcessId() {
    const checked = this.setInputTargets.find((input) => input.checked && input.value)
    return checked ? checked.value : ""
  }

  selectedTestCodes() {
    return this.testInputTargets.filter((input) => input.checked).map((input) => input.value)
  }

  needsNorms() {
    if (this.selectedTestCodes().some((code) => this.genderCodesValue.includes(code))) return true
    const set = this.setInputTargets.find((input) => input.checked && input.value)
    return set?.dataset.includesMmpi === "true"
  }
}
